import { Row } from "reactstrap"

const DeliveryPartnerPreview = props => {
  return (
    <>
      <Row>
        <h5>Application Details</h5>
        <table className="table table-striped table-responsive">
          <thead>
            <tr>
              <th>Item</th>
              <th>Value</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td> Legal Status </td>
              <td>
                {props.data.legal_status}
              </td>
            </tr>

            {/* <tr>
              <td>Document Type</td>
              <td>{props.data.document_type}</td>
            </tr> */}
            
            <tr>
              <td>Request Details</td>
              <td>
                {props.data.request_details}
              </td>
            </tr>
            
          </tbody>
        </table>
      </Row>
    </>
  )
}

export default DeliveryPartnerPreview
